import { CSSProperties } from 'react'
import DropdownInput from '@/shared/Inputs/DropdownInput'
import { IOption } from '@/types/global.ts'

export type TSortDirection = 'asc' | 'desc'

const fieldTypeOptions: IOption<TSortDirection>[] = [
  { title: 'По умолчанию (А→Я)', value: 'asc' },
  { title: '(Я→A)', value: 'desc' },
]

interface IProps {
  value: TSortDirection
  name: string
  onChange: (val: TSortDirection, name: TSortDirection) => void
  title?: string
  wrapperStyle?: CSSProperties
}

const UsersSortTypeDropdown = (props: IProps) => {
  return (
    <DropdownInput
      name={props.name}
      wrapperStyle={props.wrapperStyle}
      onSelect={props.onChange}
      options={fieldTypeOptions}
      selectedOption={props.value as any}
      title={props.title || 'Тип'}
    />
  )
}

export default UsersSortTypeDropdown
